module.exports = __webpack_public_path__ + "img/noun-child.931b621c.svg";